import { useApp } from '@components';
import { Skeleton } from 'antd';
import { observer } from 'mobx-react-lite';
import { Base, Block } from 'zf-web-components';
import { Icons } from 'zf-web-components/icons';
import { debug } from 'zf-web-infra';
import Circle from '../../../assets/circle.svg';
import { useDocumentTitle, useLoadMenu, useMenuChange } from '../hooks';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { MenuProps } from './types';

// 未改为css Module用法，由于内部有覆盖antd样式
import './index.less';

// TODO:
// 5. collapsed是否要放在app store里，为什么？

export function MenuComponent(props: MenuProps): ReactElement {
  debug.complex('Menu', props);

  // TODO: 这个得想办法处理一下
  const { loading, appMenus, systemMenus } = useLoadMenu({
    home: <Icons name='HomeFilled' />,
    eye: <Icons name='EyeFilled' />,
    'bar-chart': <Icons name='FundFilled' />,
    share: <Icons name='FolderOpenFilled' />,
    history: <Icons name='HistoryOutlined' />,
    hdd: <Icons name='DatabaseFilled' />,
    camera: <Icons name='VideoCameraFilled' />,

    // training icon
    settings: <Icons name='SettingFilled' />,
    equalizer: <Icons name='FundFilled' />,
    library: <Icons name='BookFilled' />,
    layers: <Icons name='SnippetsFilled' />,

    FundOutlined: <Icons name='MenuBiAnalyze' />,
    TableOutlined: <Icons name='TableOutlined' />,
    ProfileOutlined: <Icons name='ProfileOutlined' />,
    KubernetesOutlined: <Icons name='KubernetesOutlined' />,
    AuditOutlined: <Icons name='AuditOutlined' />,
    DotChartOutlined: <Icons name='DotChartOutlined' />,
    AppstoreOutlined: <Icons name='AppstoreOutlined' />,
    BulbOutlined: <Icons name='BulbOutlined' />,
    SettingOutlined: <Icons name='SettingOutlined' />,
    ApartmentOutlined: <Icons name='ApartmentOutlined' />,
    default: <Circle />
  });

  const { token } = Base.theme.useToken();
  const { openKeys, selectedKeys, onOpenChange, onSelect } = useMenuChange(appMenus);
  useDocumentTitle();
  const { colorPrimary: backgroundColor } = useApp();

  const style = {
    color: token.colorTextBase === '#000000'
      ? '#333333'
      : token.colorTextBase,
    // 定义CSS变量
    '--menu-selected-bg': backgroundColor
  };

  return (
    <>
      <Block if={loading}>
        <div className={styles.menuSkeleton}>
          <div className={styles.item}>
            <Skeleton.Button className={styles.title} active={true} size='default' />
          </div>
          {Array.from({ length: 5 }, (ignore, index) => <div key={index} className={styles.subItem}>
            <Skeleton.Button className={styles.subTitle} active={true} size='default' />
          </div>)}
          <div className={styles.item}>
            <Skeleton.Button className={styles.title} active={true} size='default' />
          </div>
          <div className={styles.item}>
            <Skeleton.Button className={styles.title} active={true} size='default' />
          </div>
          <div className={styles.item}>
            <Skeleton.Button className={styles.title} active={true} size='default' />
          </div>
        </div>
      </Block>
      <Block if={!loading}>
        <Base.Menu
          mode='inline'
          inlineIndent={0}
          className='menu' // TODO: 样式是否可以不直接覆盖？
          style={{ ...style, height: '100%', overflowY: 'auto' }}
          items={appMenus}
          openKeys={openKeys}
          selectedKeys={selectedKeys}
          onOpenChange={onOpenChange}
          onSelect={onSelect}
        />
        <div className={styles.siderFooter}>
          <Base.Menu
            mode='vertical'
            style={{ borderInlineEnd: 0, textAlign: 'left' }}
            theme='light'
            defaultSelectedKeys={['1']}
            expandIcon={<Icons name='SwapOutlined' />}
            items={systemMenus}
          />
        </div>
      </Block>
    </>
  );
}

export const Menu = observer(MenuComponent);
